import { CoinsIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Coins = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CoinsIcon {...rest} size={Sizes[size]} color={fill} />;
};

Coins.displayName = 'Coins';
